import { httpClient, httpClientUrlStringBuilder } from '@/network/clientController'

/** Get Portfolio of DPs List
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_termsportfolio
*/
export const getPortfolio = () => {
    return httpClient({
		method: 'GET',
		url: 'terms/portfolio',
		isCancellable: true
	})
}

/** Get List of products available for DPs subscribe
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_termsproducts
*/
export const getAvailableProducts = () => {
    return httpClient({
		method: 'GET',
		url: 'terms/products',
		isCancellable: true
	})
}

/** Get List of interest rates for a dp product
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_termsinterestRates
*/
export const getProductInterestRates = (payload) => {
    return httpClient({
		method: 'GET',
		url: 'terms/interestRates',
		params: payload,
		isCancellable: true
	})
}

/** Get List of products available for DPs subscribe
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_termsproducts%7Bid%7Dplafond_
*/
export const getProductPlafond = (payload) => {
    return httpClient({
		method: 'GET',
		url: `terms/products/${payload.id}/plafond`,
		params: payload.params,
		isCancellable: true
	})
}

/** Simulates DP
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_termssimulation
*/
export const simulateDp = (payload) => {
	return httpClient({
		method: 'GET',
		url: 'terms/simulation',
		params: payload
	})
}

/** Subscribe DP Product
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/POST_termscreateDp
*/
export const createDp = (payload) => {
	return httpClient({
		method: 'POST',
		url: 'terms/createDp',
		data: payload,
		operationTypeId: 40 /* for mocks handling of tokens */
	})
}

/** Charge DP Product
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/POST_termschargedp
*/
export const chargeDp = (payload) => {
	return httpClient({
		method: 'POST',
		url: 'terms/chargedp',
		data: payload,
		operationTypeId: 41 /* for mocks handling of tokens */
	})
}

/** creates terms receipt url
@docs não há documentação
*/
export const createTermsReceiptURL = payload => {
	return httpClientUrlStringBuilder({
		method: 'GET',
		url: 'terms/generateReceipt',
		params: payload.params
	})
}

/**
* payload
* @docs não há documentação
*/
export const sendTermsEmailNotification = payload => {
	return httpClient({
		method: 'POST',
		url: `/terms/${payload.operationId}/notification/email`,
		data: payload.data
	})
}
/**
* payload
* @docs não há documentação
*/
export const sendTermsSMSNotification = payload => {
	return httpClient({
		method: 'POST',
		url: `/terms/${payload.operationId}/notification/sms`,
		data: payload.data
	})
}
